import React from 'react';
import { connect } from 'react-redux';
import LinearProgress from '@mui/material/LinearProgress';
import { IAppState } from '../../../state/reducers';
import { IProps, IStateProps } from './interfaces';

class ExchangeLoadingIndicator extends React.Component<IProps> {
  render() {
    const { isResultsLoading, isAssetLoading } = this.props;
    return (isResultsLoading || isAssetLoading) && <LinearProgress data-tip="Loading" />;
  }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
  isResultsLoading: state.exchange?.searchResults?.isLoading ?? false,
  isAssetLoading: state.exchange?.activeAsset?.isLoading ?? false,
});

export default connect(
  mapStateToProps,
)(ExchangeLoadingIndicator);
